import { Record } from 'immutable';
import { LookupAddress } from '../../event/models/lookup-address';

const AgencyLookupSummaryRecord = Record({
  agencyId: null,
  name: null,
  agencyAlias: null,
  address: new LookupAddress({}),
  manuallyAdded: null
});

export class AgencyLookupSummary extends AgencyLookupSummaryRecord {
  agencyId: string;
  name: string;
  agencyAlias: string;
  address: LookupAddress;
  manuallyAdded: boolean;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/agency-lookup-summary.ts